import { render, staticRenderFns } from "./fccOpcaoBusca.vue?vue&type=template&id=554aa640"
import script from "./fccOpcaoBusca.vue?vue&type=script&lang=js"
export * from "./fccOpcaoBusca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports